import axios, { AxiosResponse } from 'axios';
import { iTagShort__API } from '../apiSchema';
import { getApiLink } from '../api';
import { useData } from '../hooks/useData';
import { iTag, Tag } from '../models/Tag';

/**
 * Fetch list of tags. When ribbons (aka categories) ids are provided, the backend
 * returns only the tags that belong to that ribbons. If no id is supplied the
 * endpoint returns the full tag list.
 *
 * @param ribbonsIds Optional ribbons/categories identifiers.
 */
async function getTags(ribbonsIds?: number[]): Promise<iTag[]> {
    const endpoint = ribbonsIds
        ? `Tag/GetTagsByRibbons?${ribbonsIds.map((id) => `ribbonIds=${id}`).join('&')}`
        : `Tag/GetTagsByRibbon`;

    const response: AxiosResponse<iTagShort__API[]> = await axios.get(getApiLink(endpoint));

    return response.data.map((p) => new Tag({ apiModel: p }));
}

export default function useTags(ribbonsIds?: number[]) {
    return useData([], getTags, ribbonsIds);
}
